import { formatNumberLocale } from '@/shared/utils/locale_number_utils.js';

export function formatDecimal(value, decimales = 2) {
  if (typeof value !== 'number') value = Number(value);
  if (isNaN(value)) return '';

  const precision = Number.isFinite(Number(decimales))
    ? Math.min(20, Math.max(0, Math.trunc(Number(decimales))))
    : 2;

  if (value === 0) return formatNumberLocale(0, precision);

  const absValue = Math.abs(value);

  if (absValue > 0 && absValue < 0.0001) {
    const decimalesValorPequenio = (absValue.toFixed(20).split('.')[1] || '').search(/[1-9]/) + 1;

    if (decimalesValorPequenio > 0) {
      return formatNumberLocale(value, Math.max(precision, decimalesValorPequenio));
    }
  }

  if (precision > 15) {
    return formatNumberLocale(value, precision);
  }

  const rounded =
    precision === 0
      ? Math.round(value)
      : Number(`${Math.round(Number(`${value}e${precision}`))}e-${precision}`);

  return formatNumberLocale(rounded, precision);
}
